import Disclaimer from 'components/Disclaimer/DisclaimerPresentation'

export default Disclaimer
